import React from 'react'
import { FarmerDashboardLayout } from '../layouts';
import AssistantPage from '../../application/assets/images/farmerspages/community.png'


function FarmerCommunity() {


    return (
        <FarmerDashboardLayout>


            <div className='  '>

                <img src={AssistantPage} alt="" />

            </div>


        </FarmerDashboardLayout>
    )
}

export default FarmerCommunity